import { Injectable } from '@angular/core';
import { AbaServidor, abaServidorPorUrl, itensNavegacaoServidor, rotaDaAbaServidor } from './navegacao-servidor';

export type { AbaServidor, ItemNavegacaoServidor } from './navegacao-servidor';

@Injectable({ providedIn: 'root' })
export class ServicoNavegacaoServidor {
  itens() {
    return itensNavegacaoServidor();
  }

  abaPorUrl(url: string) {
    return abaServidorPorUrl(url);
  }

  rotaDaAba(aba: AbaServidor) {
    return rotaDaAbaServidor(aba);
  }
}
